import React from 'react';
import Header from '../components/Header';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const goBack = () => {
        navigate(-1); // This will take the user back to their previous page
    };
    
    return (
        <div className="contact-page">
            {user && <Header user={user} />}
            
            <div className="contact-container">
                <div className="contact-content">
                    <div className="contact-nav">
                        <button onClick={goBack} className="back-button">
                            <span>←</span> Back
                        </button>
                    </div>
                    
                    <h1>Contact Us</h1>
                    
                    <section className="contact-info">
                        <p>Have questions or concerns about Dannytopia? We're here to help!</p>
                        
                        <div className="contact-card">
                            <div className="contact-icon">✉️</div>
                            <div className="contact-details">
                                <h2>Email Us</h2>
                                <p>For any inquiries regarding our services, subscriptions, or content:</p>
                                <a href="mailto:dannytopia.llc@gmail.com" className="contact-email">
                                    dannytopia.llc@gmail.com
                                </a>
                                <p className="response-time">We aim to respond to all inquiries within 24 hours.</p>
                            </div>
                        </div>
                        
                        <div className="contact-message">
                            <h3>How We Can Help</h3>
                            <ul>
                                <li>Subscription questions or issues</li>
                                <li>Content requests or feedback</li>
                                <li>Technical support</li>
                                <li>Privacy concerns</li>
                                <li>Partnership opportunities</li>
                            </ul>
                            
                            <p>Your satisfaction is our priority. We appreciate your feedback and are committed to providing you with the best possible experience on Dannytopia.</p>
                        </div>
                    </section>
                    
                    {/* Bottom back button */}
                    <div className="contact-nav bottom-nav">
                        <button onClick={goBack} className="back-button">
                            <span>←</span> Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact; 